import httpClient from "Api/httpClient";

const END_POINT = "/bank_accounts";

const getBankAccounts = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getBankAccount = (account_id) => {
    if (!account_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + account_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printBankAccount = (account_id) => {
    if (!account_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?account_id=" + account_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createBankAccounts = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateBankAccounts = (payload, account_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + account_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteBankAccounts = (account_id) => {
    const DELETE_END_POINT = END_POINT + "/" + account_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getBankAccounts, getBankAccount, printBankAccount, createBankAccounts, updateBankAccounts, deleteBankAccounts };
